import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './Home';
import FullAboutMe from './components/AboutMe/FullAboutMe';
import SingleProject from './components/Projects/SingleProject';
import Project from './components/Projects/Project';
import Layout from './Layout';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/aboutMe" element={<Layout><FullAboutMe /></Layout>} />
        <Route path="/project" element={<Layout><Project /></Layout>} />
        <Route path="/project/:project" element={<Layout><SingleProject /></Layout>} />
      </Routes>
    </Router>
  );
}

export default App;
